export default __webpack_public_path__ + "static/media/popup.0e3ff640.jpg";